import AddressList from './pages/AddressList';
import AlarmSetting from './pages/AlarmSetting';
import Laboratory from './pages/Laboratory';
import MyInfo from './pages/MyInfo';
import MyPersonalization from './pages/MyPersonalization';
import { MyProfileScreen } from './pages/MyProfile';
import {
  MyProfileMobileScreen,
  MyProfilePasswordScreen,
  MyProfileCustomNumberScreen,
  MyProfileRefundBankAccountScreen,
} from './pages/MyProfileDetail';
import PointOfContact from './pages/PointOfContact';
import Setting from './pages/Setting';
import type { ScreenItem } from 'shared/src/types';
import { WEB_ROUTE_PATHS } from 'shared/src/webRoutePaths';

export const MyPageScreens: ScreenItem[] = [
  {
    name: 'AddressList',
    component: AddressList,
    path: WEB_ROUTE_PATHS.AddressList,
    options: {
      title: '배송지 변경',
    },
    convertParams: props => {
      const extras = Array.isArray(props.extras)
        ? props.extras[0]
        : props.extras;

      return {
        instanceId: props.instanceId,
        ...(typeof extras === 'string' ? JSON.parse(extras) : extras),
      };
    },
  },
  {
    name: 'AlarmSetting',
    component: AlarmSetting,
    path: WEB_ROUTE_PATHS.AlarmSetting,
    options: {
      title: '알림 설정',
    },
  },
  {
    name: 'Laboratory',
    component: Laboratory,
    path: WEB_ROUTE_PATHS.Laboratory,
    options: {
      title: '실험실',
    },
  },
  {
    name: 'MyPersonalization',
    component: MyPersonalization,
    path: WEB_ROUTE_PATHS.MyPersonalization,
    options: {
      title: '맞춤 정보',
    },
    convertParams: props => {
      const extras = Array.isArray(props.extras)
        ? props.extras[0]
        : props.extras;

      return {
        instanceId: props.instanceId,
        ...(typeof extras === 'string' ? JSON.parse(extras) : extras),
      };
    },
  },
  {
    name: 'PointOfContact',
    component: PointOfContact,
    path: WEB_ROUTE_PATHS.PointOfContact,
    options: {
      title: '상담 그룹 등록',
    },
  },
  {
    name: 'Setting',
    component: Setting,
    path: WEB_ROUTE_PATHS.Setting,
    options: {
      title: '설정',
    },
  },
  {
    name: 'MyInfo',
    component: MyInfo,
    path: WEB_ROUTE_PATHS.MyInfo,
    options: {
      title: '내 정보',
    },
  },
  // 내용은 웹뷰지만 주소(`/mypage/profile`)를 유지해야 해서 전용 화면으로 둔다.
  {
    name: 'MyProfile',
    component: MyProfileScreen,
    path: WEB_ROUTE_PATHS.MyProfile,
    options: {
      title: '프로필',
    },
  },
  // 프로필 하위 개인정보 수정 화면들(로그인 필수). 타이틀은 서버 <title> 을 따른다.
  {
    name: 'MyProfileMobile',
    component: MyProfileMobileScreen,
    path: WEB_ROUTE_PATHS.MyProfileMobile,
    options: {
      title: '휴대폰 번호',
    },
  },
  {
    name: 'MyProfilePassword',
    component: MyProfilePasswordScreen,
    path: WEB_ROUTE_PATHS.MyProfilePassword,
    options: {
      title: '비밀번호',
    },
  },
  {
    name: 'MyProfileCustomNumber',
    component: MyProfileCustomNumberScreen,
    path: WEB_ROUTE_PATHS.MyProfileCustomNumber,
    options: {
      title: '개인통관고유부호',
    },
  },
  {
    name: 'MyProfileRefundBankAccount',
    component: MyProfileRefundBankAccountScreen,
    path: WEB_ROUTE_PATHS.MyProfileRefundBankAccount,
    options: {
      title: '환불계좌',
    },
  },
];
